import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Legend,
  Label,
} from "recharts";
import Footer from "../components/Footer";
import LandingSection from "../components/LandingSection";
import { Link } from "react-router-dom";

const allRawData = [
  {
    State: "Alaska",
    Overall: 3,
    Corporate: 34,
    Income: 1,
    Sales: 5,
    Property: 30,
    UI: 45,
    "income tax rate": 0,
    "prop tax rate": "1.04%",
    "sales tax rate": "1.81%",
    "corporate tax rate": "0% - 9.4%",
  },
  {
    State: "Florida",
    Overall: 4,
    Corporate: 16,
    Income: 1,
    Sales: 14,
    Property: 21,
    UI: 10,
    "income tax rate": 0,
    "prop tax rate": "0.91%",
    "sales tax rate": "7.02%",
    "corporate tax rate": "5.5%",
  },
  {
    State: "Indiana",
    Overall: 10,
    Corporate: 8,
    Income: 16,
    Sales: 17,
    Property: 5,
    UI: 13,
    "income tax rate": "3.15%",
    "prop tax rate": "0.84%",
    "sales tax rate": "7%",
    "corporate tax rate": "4.9%",
  },
  {
    State: "Montana",
    Overall: 5,
    Corporate: 19,
    Income: 10,
    Sales: 3,
    Property: 18,
    UI: 21,
    "income tax rate": "1% - 6.75%",
    "prop tax rate": "0.74%",
    "sales tax rate": "0%",
    "corporate tax rate": "6.75%",
  },
  {
    State: "New Hampshire",
    Overall: 6,
    Corporate: 32,
    Income: 12,
    Sales: 1,
    Property: 39,
    UI: 27,
    "income tax rate": "4% on interest and dividends only",
    "prop tax rate": "1.93%",
    "sales tax rate": "0%",
    "corporate tax rate": "7.25%",
  },
  {
    State: "North Dakota",
    Overall: 9,
    Corporate: 7,
    Income: 17,
    Sales: 15,
    Property: 4,
    UI: 12,
    "income tax rate": "1.1% - 2.9%",
    "prop tax rate": "0.98%",
    "sales tax rate": "7.04%",
    "corporate tax rate": "1.41% - 4.31%",
  },
  {
    State: "South Dakota",
    Overall: 2,
    Corporate: 1,
    Income: 1,
    Sales: 31,
    Property: 10,
    UI: 22,
    "income tax rate": 0,
    "prop tax rate": "1.17%",
    "sales tax rate": "6.11%",
    "corporate tax rate": 0,
  },
  {
    State: "Tennessee",
    Overall: 8,
    Corporate: 48,
    Income: 1,
    Sales: 47,
    Property: 33,
    UI: 17,
    "income tax rate": 0,
    "prop tax rate": "0.67%",
    "sales tax rate": "9.55%",
    "corporate tax rate": "6.5%",
  },
  {
    State: "Texas",
    Overall: 7,
    Corporate: 46,
    Income: 1,
    Sales: 36,
    Property: 40,
    UI: 30,
    "income tax rate": 0,
    "prop tax rate": "1.68%",
    "sales tax rate": "8.2%",
    "corporate tax rate": "-",
  },
  {
    State: "Wyoming",
    Overall: 1,
    Corporate: 1,
    Income: 1,
    Sales: 7,
    Property: 44,
    UI: 31,
    "income tax rate": 0,
    "prop tax rate": "0.56%",
    "sales tax rate": "5.44%",
    "corporate tax rate": 0,
  },
  {
    State: "Utah",
    Overall: 16,
    Corporate: 17,
    Income: 9,
    Sales: 27,
    Property: 12,
    UI: 29,
    "income tax rate": "4.85%",
    "prop tax rate": "0.57%",
    "sales tax rate": "7.2%",
    "corporate tax rate": "4.85%",
  },
];

const rawData = [...allRawData]
  .sort((a, b) => a.Overall - b.Overall)
  .slice(0, 11);

const Tax = () => {
  const [selectedState, setSelectedState] = useState(
    rawData.find((state) => state.State === "Utah") || null
  );

  const handleRowClick = (state) => {
    setSelectedState(state);
  };

  return (
    <div>
      <LandingSection
        data={{ imageName: "taxes.webp", title: "Utah Taxes", visible: "" }}
      />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Utah’s Taxes</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Understand how Utah ranks in taxation, incentives, and economic
              competitiveness.
            </p>
            <Link to={"/about"}></Link>
          </div>
        </div>
      </div>

      {/* 🔹 Box Layout */}
      <div className="max-w-[100rem] mx-auto bg-transparent">
        <h1 className="text-2xl md:text-3xl text-center font-bold mb-8 text-blue-800">
          2025 State Tax Competitiveness Rank
        </h1>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* 📊 Table */}
          <div className="w-[60rem] shadow border rounded-lg lg bg-white">
            <table className="w-full table-fixed border-collapse">
              <thead className="sticky top-0 z-10 bg-gray-100">
                <tr className="text-sm md:text-base font-semibold text-gray-700">
                  <th className="px-3 py-2">State</th>
                  <th className="px-3 py-2">Overall</th>
                  <th className="px-3 py-2">Corporate</th>
                  <th className="px-3 py-2">Income</th>
                  <th className="px-3 py-2">Sales</th>
                  <th className="px-3 py-2">Property</th>
                  <th className="px-3 py-2">UI Tax</th>
                </tr>
              </thead>
              <tbody>
                {rawData.map((item) => (
                  <tr
                    key={item.State}
                    onClick={() => handleRowClick(item)}
                    className={`cursor-pointer text-sm md:text-base ${
                      selectedState?.State === item.State
                        ? "bg-blue-100 text-blue-900 font-bold"
                        : "hover:bg-gray-50 border border-gray-300"
                    }`}
                  >
                    <td className="px-3 py-2 text-left font-semibold text-[#CB0C0C]">
                      {item.State}
                    </td>
                    <td className="px-3 py-2 border border-gray-300">
                      {item.Overall}
                    </td>
                    <td className="px-3 py-2 border border-gray-300">
                      {item.Corporate}
                    </td>
                    <td className="px-3 py-2 border border-gray-300">
                      {item.Income}
                    </td>
                    <td className="px-3 py-2 border border-gray-300">
                      {item.Sales}
                    </td>
                    <td className="px-3 py-2 border border-gray-300">
                      {item.Property}
                    </td>
                    <td className="px-3 py-2 border border-gray-300">
                      {item.UI}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* 📈 Chart + Details */}
          <div className="w-full lg:w-[40%]">
            {selectedState && (
              <div className="bg-white border rounded-lg p-6 w-full shadow-lg">
                <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                  Tax Rank Breakdown
                  <div className="text-blue-700 text-2xl font-bold mt-1">
                    {selectedState.State}
                  </div>
                </h2>

                <div className="h-[280px]">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                      data={[
                        { name: "Corporate", value: selectedState.Corporate },
                        { name: "Income", value: selectedState.Income },
                        { name: "Sales", value: selectedState.Sales },
                        { name: "Property", value: selectedState.Property },
                        { name: "UI", value: selectedState.UI },
                      ]}
                      margin={{ top: 20, right: 20, left: 0, bottom: 20 }}
                    >
                      <XAxis dataKey="name">
                        <Label
                          value="State"
                          position="bottom"
                          style={{ fill: "#111" }}
                        />{" "}
                      </XAxis>
                      <YAxis>
                        <Label
                          value="Rank"
                          angle={-90}
                          position="insideLeft"
                          style={{ fill: "#111", textAnchor: "middle" }}
                          dx={10}
                        />
                      </YAxis>
                      <Tooltip />
                      {/* <Legend /> */}
                      <Bar dataKey="value">
                        <Cell fill="#FFE4C4" />
                        <Cell fill="#6667AB" />
                        <Cell fill="#BCB88A" />
                        <Cell fill="#660000" />
                        <Cell fill="#FF77FF" />
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>

                <div className="mt-4 text-sm text-gray-700">
                  <p className="text-lg font-semibold mb-2 text-center text-blue-900">
                    Tax Rates of {selectedState.State}
                  </p>
                  <p>
                    <span className="font-semibold">Income Tax Rate:</span>{" "}
                    {selectedState["income tax rate"]}
                  </p>
                  <p>
                    <span className="font-semibold">Property Tax Rate:</span>{" "}
                    {selectedState["prop tax rate"]}
                  </p>
                  <p>
                    <span className="font-semibold">Sales Tax Rate:</span>{" "}
                    {selectedState["sales tax rate"]}
                  </p>
                  <p>
                    <span className="font-semibold">Corporate Tax Rate:</span>{" "}
                    {selectedState["corporate tax rate"]}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="text-gray-600 mt-10 mb-10 px-4 text-sm md:text-base text-center">
          Data compiled by the{" "}
          <a
            href="https://taxfoundation.org/research/all/state/2025-state-tax-competitiveness-index/"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tax Foundation
          </a>{" "}
          for the 2025 State Tax Competitiveness Index.
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Tax;
